/**-------------------------------  Copyright ---------------------------------
This software has been developed by Orange Labs TGI/OLS/SOFT
Copyright (c) Orange Labs 2018

COPYRIGHT    : This file is the property of Orange Labs.
Copyright Orange Labs 2018, All Rights Reserved

This software is the confidential and proprietary information of Orange Labs.

You shall not disclose such Confidential Information and shall use it only
in accordance with the terms of the license agreement you entered into with
Orange Labs.

AUTHORS      : Orange Labs  TGI/OLS/SOFT
EMAIL        : soft.cybersec@orange.com
-----------------------------------------------------------------------------*/


import EmailValidator from '@/utils/validators/EmailValidator'
import {OsVersionVO} from '@/valueObjects/OsVersionVO'

export enum RoleValue {
    admin = 'admin',
}

export class UserVO {
    public static fromServiceFormat(snakeCasedUserInfo: any): UserVO {
        return new UserVO(snakeCasedUserInfo.email,
            snakeCasedUserInfo.failed_attempts,
            snakeCasedUserInfo.first_name,
            snakeCasedUserInfo.last_name,
            snakeCasedUserInfo.password,
            snakeCasedUserInfo.roles,
            snakeCasedUserInfo.id,
            snakeCasedUserInfo.is_gui_interactive,
            snakeCasedUserInfo.dynamic_analysis_selected,
            OsVersionVO.fromServiceFormat(snakeCasedUserInfo.os_version),
            snakeCasedUserInfo.visibility,
            snakeCasedUserInfo.virus_total_selected,
            snakeCasedUserInfo.pfav_selected,
            snakeCasedUserInfo.nbApkPost,
            snakeCasedUserInfo.internet_selected,
        )
    }

    public static fromPersistentStore(persistentUserInfo: any): UserVO {
        return new UserVO(persistentUserInfo.email,
            persistentUserInfo.failedAttempts,
            persistentUserInfo.firstName,
            persistentUserInfo.lastName,
            persistentUserInfo.password,
            persistentUserInfo.roles,
            persistentUserInfo.id,
            persistentUserInfo.isGuiInteractive,
            persistentUserInfo.DynamicAnalysisSelected,
            OsVersionVO.fromPersistentStore(persistentUserInfo.osVersion),
            persistentUserInfo.visibility,
            persistentUserInfo.virusTotalSelected,
            persistentUserInfo.pfavSelected,
            persistentUserInfo.nbApkPost,
            persistentUserInfo.InternetSelected,
            )
    }
    public static getMapKeyValue(obj: any, key: any): any {
        if (obj.hasOwnProperty(key) && obj[key] !== undefined && obj[key] !== null && obj[key].length !== 0) {
            return obj[key]}
        return null
    }

    constructor(public email: string = 'unknown',
                public failedAttempts: number = 0,
                public firstName: string = 'unknown',
                public lastName: string = 'unknown',
                public password: string = 'unknown',
                public roles?: string[],
                public id?: number,
                public isGuiInteractive?: boolean,
                public DynamicAnalysisSelected?: boolean,
                public osVersion?: OsVersionVO,
                public visibility?: string,
                public virusTotalSelected?: boolean,
                public pfavSelected?: boolean,
                public nbApkPost?: number,
                public InternetSelected?: boolean,
    ) {
    }

    public isAdmin(): boolean {
        return this.roles.some((val) => val === RoleValue.admin)
    }

    public isValid(): boolean {
        return EmailValidator.isValid(this.email)
            && this.firstName !== ''
            && this.lastName !== ''
    }

    public toServiceFormat(): any {
        const fields: { [key: string]: any } = {
            id: 'id',
            email: 'email',
            firstName: 'first_name',
            lastName: 'last_name',
            roles: 'roles',
            isGuiInteractive: 'is_gui_interactive',
            DynamicAnalysisSelected: 'dynamic_analysis_selected',
            osVersion: 'os_version',
            visibility: 'visibility',
            virusTotalSelected: 'virus_total_selected',
            pfavSelected: 'pfav_selected',
            nbApkPost: 'nbApkPost',
            InternetSelected: 'internet_selected',
        }
        const serviceFormatUser: any = {}

        for (const property in fields) {
            if (UserVO.getMapKeyValue(this, property) != null ) {
                const field = fields[property]
                if (property === 'osVersion') {
                    const osObject = UserVO.getMapKeyValue(this, property)
                    serviceFormatUser[field] = osObject.toServiceFormat()
                } else {
                    serviceFormatUser[field] = UserVO.getMapKeyValue(this, property)
                }
            }
        }
        const count = Object.keys(serviceFormatUser).length
        return serviceFormatUser

    }
}
